module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_8004.53340fd1.png";